import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw = {
  path: "/app-car-captain",
  children: [
    {
      path: "app-download",
      name: "car-captain-app-download",
      component: () => import('@/views/app-car-captain/index.vue'),
      meta: {
        title: "佬司机",
      },
    },
    {
      path: "truck/scan/relationTruckTeam",
      name: "car-captain-relation-truck-team",
      component: () => import('@/views/app-car-captain/relation-truck-team/index.vue'),
      meta: {
        title: "佬司机车队长",
      },
    },
    {
      path: "freight-source-share",
      name: "freight-source-share",
      component: () => import('@/views/app-car-captain/freight-source-share/index.vue'),
      meta: {
        title: "货源转发",
      },
    },
    {
      path: "freight-source-hall-share",
      name: "freight-source-hall-share",
      component: () => import('@/views/app-car-captain/freight-source-hall/index.vue'),
      meta: {
        title: "货源转发",
      },
    },
    {
      path: "pre-upgrade/2-0-20",
      name: "captain-app-pre-upgrade-v2.0.20",
      component: () => import('@/views/app-car-captain/pre-upgrade/index-v2.0.20.vue'),
      meta: {
        title: "佬司机预更新介绍",
      },
    },
    {
      path: "pre-upgrade/:versionId",
      name: "captain-app-pre-upgrade",
      component: () => import('@/views/app-car-captain/pre-upgrade/index.vue'),
      props: true,
      meta: {
        title: "佬司机预更新介绍",
      },
    },
    {
      path: "/app-car-captain/:path(.*)*",
      redirect: "/app-driver/app-download"
    }
  ],
};

export default routes;
